import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Box, Typography } from '@mui/material';
import type * as v from 'valibot';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
import { ICON_URL_MAP, type IconUrlMapKeys } from './constants';
import type { CreditCardsIconItemSCSchema } from './schema';
export type CreditCardsIconItemProps = StructuredContentDocumentWithRenderer<v.InferInput<typeof CreditCardsIconItemSCSchema>>;
export const CreditCardsIconItem = t0 => {
  const $ = _c(18);
  const {
    props
  } = t0;
  const {
    icon,
    title,
    children
  } = props;
  const iconUrl = ICON_URL_MAP[icon as IconUrlMapKeys];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      gap: 2,
      paddingX: {
        xs: 0,
        sm: 3
      },
      paddingTop: 3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== icon || $[2] !== iconUrl) {
    t2 = iconUrl && <CdnImage src={iconUrl} alt={`${icon} icon`} height={24} width={24} style={{
      objectFit: "contain",
      objectPosition: "center"
    }} />;
    $[1] = icon;
    $[2] = iconUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      flexDirection: "column",
      gap: 2
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      fontSize: {
        xs: "16px",
        sm: "18px"
      }
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== title) {
    t5 = <Typography variant="textBold" sx={t4}>{title}</Typography>;
    $[6] = title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children) {
    t6 = renderStructuredContent(children);
    $[8] = children;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <Box>{t6}</Box>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <Box sx={t3}>{t5}{t7}</Box>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t8) {
    t9 = <Box sx={t1}>{t2}{t8}</Box>;
    $[15] = t2;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};